export enum Surface {
  Sand = 'Sand',
  Carpet = 'Carpet',
  Parquet = 'Parquet',
  ArtificialGrass = 'ArtificialGrass',
  Grass = 'Grass',
  HardCourt = 'HardCourt',
  Synthetic = 'Synthetic',
  CarpetGranule = 'CarpetGranule',
  Asphalt = 'Asphalt',
  Ash = 'Ash',
  RedCourt = 'RedCourt',
  Felt = 'Felt',
  Tartan = 'Tartan',
  Opticourt = 'Opticourt',
  Ice = 'Ice',
  PVC = 'PVC',
  ArtificialIce = 'ArtificialIce',
  Granule = 'Granule',
  Water = 'Water',
  Concrete = 'Concrete',
}

export enum Area {
  Indoor = 'Indoor',
  Outdoor = 'Outdoor',
}

export function mapAreaFromDB(s: string): Area | undefined {
  switch (s) {
    case 'indoor':
    case 'Indoor':
      return Area.Indoor
    case 'outdoor':
    case 'Outdoor':
      return Area.Outdoor
    default:
      return undefined
  }
}

export function mapSurfaceFromDB(s: string): Surface | undefined {
  switch (s) {
    case 'sand':
    case 'Sand':
      return Surface.Sand
    case 'Teppich':
      return Surface.Carpet
    case 'Parkett':
      return Surface.Parquet
    case 'Kunstrasen':
      return Surface.ArtificialGrass
    case 'Naturrasen':
      return Surface.Grass
    case 'Hartplatz':
      return Surface.HardCourt
    case 'Kunststoff':
      return Surface.Synthetic
    case 'Teppich-Granulat':
      return Surface.CarpetGranule
    case 'Asphalt':
      return Surface.Asphalt
    case 'Asche':
      return Surface.Ash
    case 'Red Court':
      return Surface.RedCourt
    case 'Filz':
      return Surface.Felt
    case 'Tartan':
      return Surface.Tartan
    case 'opticourt':
      return Surface.Opticourt
    case 'Eis':
      return Surface.Ice
    case 'pvc':
      return Surface.PVC
    case 'kunsteis':
      return Surface.ArtificialIce
    case 'Granulat':
      return Surface.Granule
    case 'Water':
      return Surface.Water
    case 'Beton':
      return Surface.Concrete
    default:
      return undefined
  }
}
